import OxygenInput from '@8x8/oxygen-input'
import styled from 'styled-components'

const Input = styled(OxygenInput).attrs(({ theme }) => ({
  theme: {
    backgroundColor: theme.backgroundInput,
    borderColor: theme.borderColorInput,
    color: theme.colorInput
  }
}))``

export default Input
